export default __webpack_public_path__ + "static/media/maintenance-fallback-image.7805875f.svg";